import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../lib/images';

export const About = () => {
  return (
    <section id="about" className="py-32 px-6 md:px-12 bg-background relative z-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
        
        <div className="lg:col-span-5 relative">
          <div className="text-xs uppercase tracking-[0.3em] text-secondary mb-8 font-medium">Chapter 01 — The Story</div>
          <h2 className="text-4xl md:text-6xl font-editorial leading-tight mb-8">
            Transforming visions into <span className="italic text-secondary">seamless</span> celebrations.
          </h2>
          <div className="space-y-6 text-foreground/80 font-light leading-relaxed text-lg">
            <p>
              Based in the heart of Jaipur, Nirvaana Events has redefined the standard of luxury hospitality and event management over the last seven years.
            </p>
            <p>
              From royal palace weddings to elegant corporate summits, our philosophy remains the same: complete precision. We believe that behind every effortless celebration is a masterclass in logistics, crisis management, and unparalleled communication.
            </p>
          </div>
          
          <div className="mt-12 pt-12 border-t border-border">
            <div className="flex items-center gap-6">
              <img src={IMAGES.founder} alt="Rajat Gupta" className="w-16 h-16 rounded-full object-cover grayscale" />
              <div>
                <p className="font-editorial text-2xl">Rajat Gupta</p>
                <p className="text-xs uppercase tracking-widest text-muted-foreground mt-1">Founder, 567+ Events</p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 relative h-[600px] md:h-[800px] w-full group">
          <motion.div 
            initial={{ clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)' }}
            whileInView={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.5, ease: [0.76, 0, 0.24, 1] }}
            className="w-full h-full overflow-hidden"
          >
            <img 
              src={IMAGES.portfolio[1]} 
              alt="Nirvaana Story" 
              className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000 ease-out"
            />
          </motion.div>
        </div>

      </div>
    </section>
  );
};
